import { Logout, FetchUser, FetchUserNotificationsConfig } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { UserState } from './types'

const getInitialState = (): UserState => ({
  user: null,
  accessInfo: null,
  isUserInitialized: false,
  userNotificationConfig: null,
})

export const userReducer = (
  state: UserState = getInitialState(),
  action: Action<any>,
): UserState => {
  switch (action.type) {
    case FetchUser.type.SUCCESS:
      return {
        ...state,
        isUserInitialized: true,
        user: action.payload.user,
        accessInfo: action.payload.accessInfo,
      }
    case FetchUserNotificationsConfig.type.SUCCESS:
      return {
        ...state,
        userNotificationConfig: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
